// 授权模块

import { Service_AppKey }from '@/service/platform_config'
import { COU_httpGet, COU_httpPost } from '@/utils/http'

// 获取授权链接
async function GetAuthUrl() {
  let url = `/needAuthInfo?appKey=${Service_AppKey}`
  var r = await COU_httpGet({url})
  var authUrl = ``
  try {
    authUrl =r.result.ClickUrl
  } catch (error) {
    console.log(error)
  }

  return authUrl
}

// 通过loginCode 获取授权信息
async function GetAuthInfoByLoginCode(loginCode) {
  var url = `/auth/login`
  var data = {
    loginCode
  }
  var r = await COU_httpPost({url, data})
  var memberInfo = {}
  try {
    memberInfo = r.result.user
  } catch (error) {
    console.log(error)
  }

  return memberInfo || {}
}

// 获取1688授权应用列表
async function GetAuthAppList(page,size,branchGroupRelId,appKeys) {
  var url = `/auth/beAuthorizeList?page=${page}&size=${size}&appKeys=${appKeys}&branchGroupRelId=${branchGroupRelId || ''}`
  var r = await COU_httpGet({url})
  var msg = ``
  var success = false
  var authMallList = []
  var total = 0
  try {
    msg = r.msg
    success = r.success
    total = r.result.TotalNum
    authMallList = r.result.Datas
  } catch (error) {
    console.log(error)
  }

  return {msg, success, authMallList:authMallList || [],total}
}

// 获取添加授权店铺的链接 (店铺绑定晓风分销应用)
async function GetAddAuthAppLink(appKey,branchGroupRelId) {
  var url = `/auth/relatedAuthUrl?appKey=${appKey}&branchGroupRelId=${branchGroupRelId}&isBeRelated=true`
  var r = await COU_httpGet({url})
  var addMallLink = ``
  try {
    addMallLink = r.result.ClickUrl
  } catch (error) {
    console.log(error)
  }

  return addMallLink
}

// 删除1688授权账号
async function DeleteAliAuth(relationId) {
  var url = `/auth/deleteAuthRelation?relationId=${relationId}`
  var r = await COU_httpPost({ url })
  let success = false, msg = ''
  try {
    success = r.success
    msg = r.msg
  } 
  catch (error) {
    console.log(error)
  }
  return { success, msg }
}

// 获取当前用户的详情数据
async function GetCurrentUserData(token) {
  const r = await COU_httpGet({ url: '/auth/info', header: { token } })
  let success = false, msg = '', result = {}
  try {
    success = r.success
    msg = r.msg
    result = r.result
  } 
  catch (error) {
    console.log(error)
  }
  result = result || {}
  return { success, msg, result }
}

export default { GetAuthUrl, GetAuthInfoByLoginCode, GetAuthAppList, GetAddAuthAppLink, DeleteAliAuth, GetCurrentUserData }